/* tslint:disable */
const TRANSLATIONS: any = {
  "i18n.additionalProducts.addToCart": "Aan de bestelling toevoegen",
  "i18n.additionalProducts.emotionalHook": "♥️ Graag genomen:",
  "i18n.additionalProducts.productDescription": "Productbeschrijving",
  "i18n.additionalProducts.showMore": "Meer informatie",
  "i18n.additionalProducts.title": "Passende puzzel benodigdheden",
  "i18n.button.addToCart": "In de winkelwagen",
  "i18n.button.cropImage": "",
  "i18n.button.apply": "Toepassen",
  "i18n.button.back": "Terug",
  "i18n.button.cancel": "Annuleren",
  "i18n.button.cancelAndFix": "",
  "i18n.button.cancelAndAddImage": "",
  "i18n.button.close": "Sluiten",
  "i18n.button.continue": "Verder",
  "i18n.button.ignore": "Ignoreren",
  "i18n.button.ignoreAndContinue": "Toch verder gaan",
  "i18n.button.ignoreAndContinueOrder": "",
  "i18n.button.mobile.createNewTextPlaceholders": "Tekst plaatsen",
  "i18n.button.noChanges": "Zonder SMART SORTED",
  "i18n.button.design": "",
  "i18n.button.photos": "Foto's",
  "i18n.button.retry": "Opnieuw proberen",
  "i18n.button.uploadPhotos": "Upload foto('s)",
  "i18n.button.withSmartSorted": "Met SMART SORTED",
  "i18n.button.withoutSmartSorted": "Zonder SMART SORTED",
  "i18n.button.continueDesigning": "",
  "i18n.button.returnToHomePage": "",
  "i18n.button.deleteImage": "",
  "i18n.button.withoutPhoto": "",
  "i18n.button.withoutThisPhoto": "",
  "i18n.button.chooseNewImage": "",
  "i18n.button.chooseOtherPhoto": "",
  "i18n.button.retryPhoto": "",
  "i18n.button.reload": "",
  "i18n.button.restartDesigner": "",
  "i18n.button.restart": "",
  "i18n.button.puzzleYouShop": "",
  "i18n.button.shop": "",
  "i18n.button.changeProduct": "",
  "i18n.button.keepProduct": "",
  "i18n.toggle.hidePuzzleOverlay": "",
  "i18n.toggle.showPuzzleOverlay": "",
  "i18n.toggle.hide": "",
  "i18n.toggle.showUsedImages": "",
  "i18n.toggle.hideUsedImages": "",
  "i18n.imagePromoter.title": "",
  "i18n.imagePromoter.content": "",
  "i18n.boxPromoter.title.puzzle": "",
  "i18n.boxPromoter.title.memo": "",
  "i18n.boxPromoter.title.default": "",
  "i18n.boxPromoter.content.designsAndText": "",
  "i18n.boxPromoter.content.designs": "",
  "i18n.boxPromoter.content.text": "",
  "i18n.control.colorChooser.matchingColors": "",
  "i18n.control.colorChooser.allColors": "",
  "i18n.control.colorChooser.allBgColors": "",
  "i18n.control.colorChooser.lowContrastHint": "",
  "i18n.control.fontChooser.group.classic": "",
  "i18n.control.fontChooser.group.creative": "",
  "i18n.control.fontChooser.group.handwritten": "",
  "i18n.control.fontChooser.group.modern": "",
  "i18n.control.fontChooser.group.technical": "",
  "i18n.control.imageQuality.title.good": "",
  "i18n.control.imageQuality.title.medium": "",
  "i18n.control.imageQuality.title.bad": "",
  "i18n.control.imageQuality.content.good": "",
  "i18n.control.imageQuality.content.medium": "",
  "i18n.control.imageQuality.content.bad": "",
  "i18n.control.imageQuality.affectedImages": [
    "",
    ""
  ],
  "i18n.control.imageQuality.showIndicators": "",
  "i18n.control.imageQuality.hideIndicators": "",
  "i18n.control.imageZoom.zoom": "Zoom:",
  "i18n.control.textEditing.menu.fonts": "",
  "i18n.control.textEditing.menu.effects": "",
  "i18n.control.textEditing.menu.colors": "",
  "i18n.control.textEditing.menu.bgColors": "",
  "i18n.control.textEditing.rejectMessage.characterWontFit": "Voor een betere leesbaarheid, a.u.b. de tekst / lengte van de regel inkorten.",
  "i18n.control.textEditing.rejectMessage.fontFamilyTooLarge": "Het gekozen lettertype is te groot voor deze tekst.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooLarge": "Het maximale letterformaat voor deze tekst is bereikt.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooSmall": "Het minimale letterformaat voor deze tekst is bereikt.",
  "i18n.control.textEditing.rejectMessage.insertLineBreak": "Voor een betere leesbaarheid, a.u.b. de tekst / lengte van de regel inkorten.",
  "i18n.control.textEditing.rejectMessage.insertLineBreakOrResizeTextField": "Voeg a.u.b. een regeleinde in",
  "i18n.control.textEditing.rejectMessage.invalidCharacters": "Controleer a.u.b. je tekst. Dit lettertype ondersteunt niet alle tekens.",
  "i18n.control.textEditing.rejectMessage.maxCharactersReached": "",
  "i18n.control.textEditing.rejectMessage.maxLinesReached": "Voor een betere leesbaarheid, a.u.b. de tekst / lengte van de regel inkorten.",
  "i18n.control.textEditing.rejectMessage.resizeTextField": "A.u.b. het tekstveld groter maken",
  "i18n.dialog.closeDesigner.message": "",
  "i18n.dialog.closeDesigner.title": "",
  "i18n.dialog.deletePlaceholder.message": "Deze stap kan niet ongedaan worden gemaakt",
  "i18n.dialog.deletePlaceholder.title": "Plaatshouder echt wissen?",
  "i18n.dialog.deleteGalleryImage.title": "",
  "i18n.dialog.deleteGalleryImage.message": "",
  "i18n.dialog.insufficientImageQuality.message": "De resolutie van deze foto is te laag om de foto scherp te kunnen drukken!",
  "i18n.dialog.smartSorted.message": "Met SMART SORTED maak je jouw fotopuzzel met 1000 stukjes op een innovatieve en ontspannen manier af, zelfs zonder een voorbeeldfoto.",
  "i18n.dialog.smartSorted.title": "Puzzel succes belevenis gegarandeerd",
  "i18n.dialog.unchangedPlaceholders.boxTitle.message": "Klik op \"{{text}}\", om de titel op de doos te veranderen.",
  "i18n.dialog.unchangedPlaceholders.boxTitle.title": "De titel op de doos is niet veranderd",
  "i18n.dialog.unchangedPlaceholders.buttons.addTitle.label": "",
  "i18n.dialog.unchangedPlaceholders.buttons.clear.label": "Verder gaan zonder titel op de doos",
  "i18n.dialog.unchangedPlaceholders.image.message": [
    "",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.image.title": [
    "",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.message": [
    "Een plaatshouder is nog niet veranderd.",
    "Sommige plaatshouders zijn nog niet veranderd."
  ],
  "i18n.dialog.unchangedPlaceholders.text.message": [
    "",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.text.title": [
    "",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.title": "Onveranderde plaatshouders",
  "i18n.dialog.productChooserWarning.title": "",
  "i18n.dialog.productChooserWarning.message": "",
  "i18n.dialog.imageQuality.title": "",
  "i18n.dialog.imageQuality.indicator.good": "",
  "i18n.dialog.imageQuality.indicator.medium": "",
  "i18n.dialog.imageQuality.indicator.bad": "",
  "i18n.dialog.imageQuality.subtitle.good": "",
  "i18n.dialog.imageQuality.subtitle.medium": "",
  "i18n.dialog.imageQuality.subtitle.bad": "",
  "i18n.dialog.imageQuality.content.good": "",
  "i18n.dialog.imageQuality.content.medium": "",
  "i18n.dialog.imageQuality.content.bad": "",
  "i18n.error.deprecatedBrowserError.message": "",
  "i18n.error.deprecatedBrowserError.title": "",
  "i18n.error.designerExpiredError.message": "Er is tijdens het ontwerpen een te lange pauze gemaakt, helaas kan het nu niet meer worden voortgezet. Wilt u het ontwerpproces a.u.b. opnieuw beginnen?",
  "i18n.error.designerExpiredError.title": "",
  "i18n.error.fontLoadingError.message": "",
  "i18n.error.fontLoadingError.title": "",
  "i18n.error.imageLoadingError.message": "Eén foto kon niet worden geupload\nHij is uit de galerij en het ontwerpgedeelte verwijderd.",
  "i18n.error.imageLoadingError.title": "Download fout",
  "i18n.error.imageProvisionError.message": "Eén of meerdere foto's konden niet worden verwerkt. Het mediatype wordt waarschijnlijk niet ondersteund.",
  "i18n.error.imageProvisionError.title": "",
  "i18n.error.imageSelectionError.message": "File \"{{reference1}}\" kon niet worden verwerkt.",
  "i18n.error.imageSelectionError.title": "Fout tijdens foto upload",
  "i18n.error.imageSizeLimitExceededError.message": "De foto die je hebt geüpload is te omvangrijk.\nVerklein je foto tot minder dan 180 megapixels en upload hem opnieuw.",
  "i18n.error.imageSizeLimitExceededError.title": "Fout tijdens foto upload",
  "i18n.error.imageUploadError.message": "Er is een probleem met de internetverbinding opgetreden.\nProbeer het a.u.b. later nog een keer.",
  "i18n.error.imageUploadError.title": "Fout tijdens foto upload",
  "i18n.error.inlineSVGLoadingError.message": "",
  "i18n.error.inlineSVGLoadingError.title": "",
  "i18n.error.invalidCharConfigError.message": "Dit lettertype kan niet worden toegepast",
  "i18n.error.invalidCharConfigError.title": "Lettertype niet passend",
  "i18n.error.malformedProductError.message": "",
  "i18n.error.malformedProductError.title": "",
  "i18n.error.notInStockError.message": "",
  "i18n.error.notInStockError.title": "",
  "i18n.error.offlineNotice": "Je internetverbinding lijkt te zijn onderbroken. Je kunt het ontwerpen van jouw product voortzetten, zodra je internetverbinding is hersteld.",
  "i18n.error.templateLoadingError.message": "Template \"{{ error.reference[0] }}\" kon niet worden geladen.\nProbeer het a.u.b. later nog een keer.",
  "i18n.error.templateLoadingError.title": "Download fout",
  "i18n.error.traudlLoadingError.message": "",
  "i18n.error.traudlLoadingError.title": "",
  "i18n.error.unsupportedMediaTypeError.message": "\"{{reference1}}\" heeft een niet ondersteund mediatype.",
  "i18n.error.unsupportedMediaTypeError.title": "Fout tijdens foto upload",
  "i18n.error.uploadProductError.message": "Eén of meerdere producten konden niet naar de server worden gestuurd.\nProbeer het a.u.b. later nog een keer.",
  "i18n.error.uploadProductError.title": "Transfer fout",
  "i18n.error.zoomModeError.message": "De tekst kon niet worden overgenomen. Vul a.u.b. een nieuwe tekst in",
  "i18n.error.zoomModeError.title": "Tekst niet geadopteerd",
  "i18n.gallery.uploadPhotos.title": "",
  "i18n.gallery.uploadPhotos.message": "",
  "i18n.gallery.placedAllPhotos.title": "",
  "i18n.gallery.placedAllPhotos.message": "",
  "i18n.price.price": "Prijs",
  "i18n.price.reduction": "Je spaart",
  "i18n.price.total": "Prijs totaal",
  "i18n.priceDisplay.times": [
    "{{value}} stuk à {{pricePerUnit}}",
    "{{value}} stuks à {{pricePerUnit}}"
  ],
  "i18n.progress.stepAdditionalProducts": "Puzzelbenodigdheden kiezen",
  "i18n.progressOverlay.message.lines.one": "Bedankt voor je ontwerp.",
  "i18n.progressOverlay.message.lines.two": "We bereiden de volgende stap voor je voor...",
  "i18n.template.insertText": "Hier een tekst invullen",
  "i18n.toolbox.image.title": "Bewerk foto",
  "i18n.toolbox.layout.template.count": [
    "",
    ""
  ],
  "i18n.toolbox.layout.template.inUse": "",
  "i18n.toolbox.layout.template.suitableFor": [
    "1 foto",
    "{{value}} foto's"
  ],
  "i18n.toolbox.layout.title": "",
  "i18n.toolbox.layout.titleBox": "",
  "i18n.toolbox.preview.title": "3D Preview",
  "i18n.toolbox.productChooser.title": "Verander product",
  "i18n.toolbox.productChooser.triggerText": "Product",
  "i18n.toolbox.productChooser.contentMessage.one": "",
  "i18n.toolbox.productChooser.contentMessage.two": "",
  "i18n.toolbox.textEdit.title": "",
  "i18n.toolbox.textEdit.noPlaceholdersTitle": "",
  "i18n.toolbox.textEdit.noPlaceholdersMessage": "",
  "i18n.toolbox.textEdit.noPlaceholdersButton": "",
  "i18n.toolbox.text.title": "Tekst bewerken",
  "i18n.toolbox.imageEdit.title": "",
  "i18n.toolbox.imageEdit.removeImageMobile": "",
  "i18n.toolbox.imageEdit.removeImageDesktop": "",
  "i18n.toolbox.imageEdit.swapImage": ""
};


export class LocaleNlNL {
  public getPlural(n: number): number
  {
    const pluralForm = (n != 1);
    if (typeof(pluralForm) === 'boolean') {
      return pluralForm ? 1 : 0;
    }
    return pluralForm;
  }
  public getTranslations(): any
  {
    return TRANSLATIONS;
  }
}
/* tslint:enable */
